import { Account, MerchantBillingInformation } from '../models/app';
import { parseLocale } from '../utils/i18n/locale';
import i18n from 'i18next';
import { getAccountFromStorage } from '../utils/sessionStorage';

export const getMerchantCountry = (account?: Account): Maybe<CountryCode> => {
  return account?.primaryMerchant?.address.country;
};

/**
 * Get country from Primary merchant's address or if not present then get from Locale(In logged out mode, there is no merchant)
 * @param account, if account is not passed it will look into the sessionStorage for account
 */
export const getCountry = (account?: Account): { country: CountryCode; isUS: boolean } => {
  account =  account || getAccountFromStorage();

  const US_CODE = 'US';
  const merchantCountry = getMerchantCountry(account),
    localeCountry = parseLocale(i18n.language).country,
    country = merchantCountry || localeCountry,
    isUS = merchantCountry ? merchantCountry === US_CODE && localeCountry === US_CODE : localeCountry === US_CODE;
  return {
    country,
    isUS,
  };
};

export const isMerchantAccountDelinquent = (merchantBillingInformation: Maybe<MerchantBillingInformation>): boolean => {
  /* If either of allowPaidAppUpgrades or allowPaidAppInstalls is false, then account is delinquent */
  const isMerchantAllowedAppUpgradesOrInstall = merchantBillingInformation?.appMarketConfig.allowPaidAppUpgrades &&
  merchantBillingInformation?.appMarketConfig.allowPaidAppInstalls

  if(isMerchantAllowedAppUpgradesOrInstall === undefined){
    return false;
  }
  else{
    return !isMerchantAllowedAppUpgradesOrInstall;
  }
};
